/* 🤖 this file was generated by svg-to-ts */
export const siriusWrench: {
  name: 'wrench';
  data: string;
} = {
  name: 'wrench',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.93 3.83a5.24 5.24 0 0 0-5.525 7.702.75.75 0 0 1-.165.933l-6.07 5.24a1.504 1.504 0 0 0 2.126 2.126l5.24-6.071.567.49.365-.655A5.24 5.24 0 0 0 20.17 8.07l-3.045 3.053a.75.75 0 0 1-.68.205l-2.652-.534a.75.75 0 0 1-.588-.588l-.534-2.653a.75.75 0 0 1 .206-.679l3.052-3.045Zm-3.64 11.35-4.878 5.654a3.004 3.004 0 1 1-4.245-4.245l5.653-4.88a6.74 6.74 0 0 1 8.819-8.92.75.75 0 0 1 .234 1.22l-3.652 3.644.356 1.77 1.77.356 3.644-3.652a.75.75 0 0 1 1.22.234 6.74 6.74 0 0 1-8.92 8.82Z" fill="currentColor"/></svg>`
};
